import { render, staticRenderFns } from "./AccountOverview.vue?vue&type=template&id=2d1db9dc"
import script from "./AccountOverview.vue?vue&type=script&lang=js"
export * from "./AccountOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports